import { render, staticRenderFns } from "./ManageTransactionsCorp.vue?vue&type=template&id=c2875030"
import script from "./ManageTransactionsCorp.vue?vue&type=script&lang=js"
export * from "./ManageTransactionsCorp.vue?vue&type=script&lang=js"
import style0 from "./ManageTransactionsCorp.vue?vue&type=style&index=0&id=c2875030&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports